import { create } from 'zustand';

const useErrorStore = create((set) => ({
    error: null,
    storeError: (error) => set(() => ({ error: error }))
}));

export default useErrorStore;